var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchTableIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 1L13 3.54545M13 3.54545L10.3333 6.09091M13 3.54545H3.66667C2.95942 3.54545 2.28115 3.81364 1.78105 4.291C1.28095 4.76837 1 5.41581 1 6.09091V7.36364M3.66667 15L1 12.4545M1 12.4545L3.66667 9.90909M1 12.4545H10.3333C11.0406 12.4545 11.7189 12.1864 12.219 11.709C12.719 11.2316 13 10.5842 13 9.90909V8.63636",
    stroke: "#e6e7f0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchTableIconGray);
export default __webpack_public_path__ + "static/media/switchTableIconGray.534d1f19bdbff5126cbcf6228093ae79.svg";
export { ForwardRef as ReactComponent };